// Init Vars
const {ADDITIONAL_LANG_STRINGS} = require('../helper/init');

/**
 * checkArbeitsmittelClick
 * @param element
 */
window.checkArbeitsmittelClick = function(element) {
  $(element).on('click', function(e) {
    if (!$(e.target).closest('div').hasClass('no-click')) {
      const row = $(e.target).closest(element);
      openArbeitsmittel(Number(row.data('id')));
    }
  });
};

/**
 * openArbeitsmittel
 * @param id
 */
window.openArbeitsmittel = function(id) {
  window.location = BASE_PATH + 'betriebsdaten/arbeitsmittelEdit/' + id;
};

/**
 * set correct equipment type
 * @param allData
 * @param ID
 */
window.setCorrectEquipmentType = function(allData, ID) {
  // Reset classes
  allData.equipmentType.attr('class', 'col-xs-12 col-md-4');
  allData.manufacturer.attr('class', 'col-xs-6 col-md-2');
  allData.tankSize.attr('class', 'col-xs-6 col-md-2');
  allData.waterCapacityArea.attr('class', 'col-xs-6 col-md-2');
  allData.buyDate.attr('class', 'col-xs-6 col-md-2');
  allData.agriosCompliant.attr('class', 'col-xs-6 col-md-2');
  allData.name.attr('class', 'col-xs-12 col-md-4');
  allData.shortTag.attr('class', 'col-xs-6 col-md-2');
  allData.chassisNumber.attr('class', 'col-xs-6 col-md-2');
  allData.validUntil.attr('class', 'col-xs-6 col-md-2');
  allData.validUntil.find('span.label').html(LANG_STRINGS.spruehertestGueltigBis + ' *');
  allData.validUntil.find('input').attr('placeholder', LANG_STRINGS.spruehertestGueltigBis + ' *');
  allData.archived.attr('class', 'col-xs-6 col-md-2');

  allData.tooltipAttachment.html('');

  if (ID === 25 || ID === 32 || ID === 44) {
    // Traktor, Hebebühne, Erntemaschine
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show().attr('class', 'col-xs-6 col-md-4');
    allData.shortTag.show().attr('class', 'col-xs-6 col-md-4');
    allData.buyDate.show();
    allData.archived.show();

    allData.validUntil.show();
    allData.validUntil.find('span.label').html(LANG_STRINGS.revisionGueltigBis);
    allData.validUntil.find('input').attr('placeholder', LANG_STRINGS.revisionGueltigBis);

  } else if (ID === 27) {
    // Sprühgerät
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show();
    allData.shortTag.show();
    allData.tankSize.show();
    allData.chassisNumber.show();
    allData.buyDate.show();
    allData.agriosCompliant.show();
    allData.archived.show();
    allData.validUntil.show();
    allData.code.show();
    allData.gueltigBis.show();
    allData.standardsprueher.show();
    if (ID === 27) {
      allData.betriebsleiter.show();
    }
    allData.attachment.show();

    // Tooltip
    allData.tooltipAttachment.show().html('<i class="material-icons-outlined vam tooltip-bottom" data-title="' + ADDITIONAL_LANG_STRINGS.ANHANG_INFO_SPRUEHGERAET + '">help</i>');
    destroyTooltips();
    initTooltip();
  } else if (ID === 28) {
    // Herbizidgerät
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show().attr('class', 'col-xs-6 col-md-4');
    allData.shortTag.show().attr('class', 'col-xs-6 col-md-4');
    allData.waterCapacityArea.show();
    allData.buyDate.show();
    allData.archived.show();

    allData.validUntil.show();
    allData.validUntil.find('span.label').html(LANG_STRINGS.funktionskontrolleGueltigBis);
    allData.validUntil.find('input').attr('placeholder', LANG_STRINGS.funktionskontrolleGueltigBis);
    allData.code.show();
    allData.gueltigBis.show();
    allData.betriebsleiter.show();
    allData.attachment.show();

    // Tooltip
    allData.tooltipAttachment.show().html('<i class="material-icons-outlined vam tooltip-bottom" data-title="' + ADDITIONAL_LANG_STRINGS.ANHANG_INFO_HERBIZIDGERAET + '">help</i>');
    destroyTooltips();
    initTooltip();
  } else if (ID === 30 || ID === 72) {
    // Handarbeit, Tropfberegnung
    allData.equipmentType.show();
    allData.name.show();
    allData.shortTag.show().attr('class', 'col-xs-6 col-md-4');
    allData.archived.show();
  } else if (ID === 327) {
    // Rückenspritze ohne Gebläse
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show();
    allData.shortTag.show();
    allData.tankSize.show();
    allData.buyDate.show();
    allData.agriosCompliant.show();
    allData.archived.show();
    allData.obstbau.show();
    allData.standardsprueher.show();
  } else if (ID === 328) {
    // Rückenspritze ohne Gebläse Herbizid
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show();
    allData.shortTag.show();
    allData.waterCapacityArea.show();
    allData.buyDate.show();
    allData.archived.show();
    allData.obstbau.show();
  } else if (ID === 24 || ID === 101) {
    // Düngerstreuer
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show().attr('class', 'col-xs-6 col-md-4');
    allData.shortTag.show().attr('class', 'col-xs-6 col-md-4');
    allData.buyDate.show().attr('class', 'col-xs-6 col-md-4');
    allData.archived.show();
    allData.code.show();
    allData.gueltigBis.show();
    allData.betriebsleiter.show();
  } else if (ID === 102) {
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show().attr('class', 'col-xs-6 col-md-4');
    allData.shortTag.show().attr('class', 'col-xs-6 col-md-4');
    allData.buyDate.show().attr('class', 'col-xs-6 col-md-4');
    allData.archived.show();
    allData.standardsprueher.show();
  } else {
    allData.equipmentType.show();
    allData.name.show();
    allData.manufacturer.show().attr('class', 'col-xs-6 col-md-4');
    allData.shortTag.show().attr('class', 'col-xs-6 col-md-4');
    allData.buyDate.show().attr('class', 'col-xs-6 col-md-4');
    allData.archived.show();
  }
};